module.exports = __webpack_public_path__ + "static/media/2020.9.28区域化党建志愿服务活动.8177b9ee.jpg";